<template>
  <div>
    <div class="p-4 mb-6" style="border-bottom: 1px solid #cdcdcd; font-size: 16px; font-weight: 500">I. 아래 사항을 직접 기입해 주시기 바랍니다.</div>

    <!-- 기본정보 -->
    <field-select-module class="mb-6" v-model="form.stdInfo" :board="this.board" :is-print="isPrint" :types="['date']" />

    <!-- 증상조사 대상자 정보 -->
    <div>
      <vs-row class="mt-6">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i> 증상조사 대상자 정보</h5>
        </vs-col>
      </vs-row>

      <div class="writeGridContainer mt-4">
        <div>
          <div>종사자(ID) 선택</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_1 }}</p>
          <EmployeeSelector v-else v-model="form.inputA_1" @select="onSelectEmployee" />
        </div>
      </div>
      <div class="writeGridContainer mt-4">
        <div>
          <div>성명</div>
          <p v-if="isPrint" class="print-input">{{ form.name }}</p>
          <ml-input v-else v-model="form.name" :readonly="true" />
        </div>
        <div>
          <div>연령</div>
          <span class="title mr-1">만</span>
          <p v-if="isPrint" class="print-input">{{ form.age }}</p>
          <ml-input v-else v-model="form.age" :readonly="true" />
          <span class="title ml-1">세</span>
        </div>
        <div>
          <div>성별</div>
          <p v-if="isPrint" class="print-input">{{ form.gender }}</p>
          <div v-else>
            <vs-radio class="mr-4" v-model="form.gender" vs-name="gender" vs-value="남" color="secondary">남</vs-radio>
            <vs-radio v-model="form.gender" vs-name="gender" vs-value="여" color="secondary">여</vs-radio>
          </div>
        </div>

        <div>
          <div>사업장명</div>
          <span v-if="isPrint" class="print-input"> {{ form.fieldNames }} </span>
          <multiselect v-else :options="fieldNameList" v-model="form.fieldNames" :multiple="true" placeholder="" selectLabel="" deselectLabel="" :showNoResults="false" :readonly="true">
            <template slot="option" slot-scope="props">
              <div>{{ props.option }}</div>
            </template>
          </multiselect>
        </div>
        <div>
          <div>현 직장경력<br>(~년/개월)</div>
          <p v-if="isPrint" class="print-input">{{ form.workExperience }}</p>
          <ml-input v-else v-model="form.workExperience" :readonly="true" />
        </div>
        <div/>

        <div>
          <div>부서명</div>
          <p v-if="isPrint" class="print-input">{{ form.workDepartment }}</p>
          <ml-input v-else v-model="form.workDepartment" :readonly="true" />
        </div>
        <div>
          <div>라인</div>
          <p v-if="isPrint" class="print-input">{{ form.workLine }}</p>
          <ml-input v-else v-model="form.workLine" :readonly="board.readonly" />
        </div>
        <div>
          <div>작업</div>
          <p v-if="isPrint" class="print-input">{{ form.workPerform }}</p>
          <ml-input v-else v-model="form.workPerform" :readonly="board.readonly" />
        </div>

        <div class="writeGridLineItem">
          <div>결혼여부</div>
          <p v-if="isPrint" class="print-input">{{ form.marriage }}</p>
          <div v-else>
            <vs-radio class="mr-4" v-model="form.marriage" vs-name="marriage" vs-value="미혼" color="secondary">미혼</vs-radio>
            <vs-radio v-model="form.marriage" vs-name="marriage" vs-value="기혼" color="secondary">기혼</vs-radio>
          </div>
        </div>

        <div>
          <div>현재하고 있는 작업<br>(구체적으로)</div>
          <p v-if="isPrint" class="print-input">{{ form.currentWork }}</p>
          <ml-input v-else v-model="form.currentWork" :readonly="board.readonly" />
        </div>
        <div>
          <div>작업기간</div>
          <div v-if="isPrint" class="print-input text-right" >
            {{ form.currentPeriod1 }}
            <span class="px-2">년</span>
            {{ form.currentPeriod2 }}
            <span class="pl-2">개월</span>
          </div>
          <div v-else class="w-full grid" style="grid-template-columns: 1fr auto 1fr auto; align-items: center;" >
            <ml-input class="w-full" v-model="form.currentPeriod1" :readonly="board.readonly" />
            <span class="px-2">년</span>
            <ml-input class="w-full" v-model="form.currentPeriod2" :readonly="board.readonly" />
            <span class="pl-2">개월</span>
          </div>
        </div>
        <div/>

        <div>
          <div>1일 근무시간</div>
          <p v-if="isPrint" class="print-input">{{ form.dayWorkTime }}</p>
          <ml-input v-else class="w-full" v-model="form.dayWorkTime" :readonly="board.readonly" />
        </div>
        <div>
          <div>근무 중 휴식시간<br>(식사시간 제외)</div>
          <p v-if="isPrint" class="print-input">{{ form.dayRestTime1 }}</p>
          <ml-input v-else class="w-full" v-model="form.dayRestTime1" :readonly="board.readonly" />
          <span class="title ml-1">분</span>
        </div>
        <div/>

        <div>
          <div>현작업을 하기 전에<br>했던 작업</div>
          <p v-if="isPrint" class="print-input">{{ form.prevWork }}</p>
          <ml-input v-else class="w-full" v-model="form.prevWork" :readonly="board.readonly" />
        </div>
        <div>
          <div>작업기간</div>
          <div v-if="isPrint" class="print-input text-right" >
            {{ form.prevPeriod1 }}
            <span class="px-2">년</span>
            {{ form.prevPeriod2 }}
            <span class="pl-2">개월</span>
          </div>
          <div v-else class="w-full grid" style="grid-template-columns: 1fr auto 1fr auto; align-items: center;" >
            <ml-input class="w-full" v-model="form.prevPeriod1" :readonly="board.readonly" />
            <span class="px-2">년</span>
            <ml-input class="w-full" v-model="form.prevPeriod2" :readonly="board.readonly" />
            <span class="pl-2">개월</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 증상조사표표 -->
    <symptom-investigation-table class="mb-6" v-model="form.symptomTable" :is-print="isPrint" :readonly="board.readonly" />

    <!-- 유의사항 -->
    <warning-view
      class="mb-6"
      :list="[
        '부담작업을 수행하는 근로자가 직접 읽어보고 문항을 체크합니다.',
        '증상조사표를 작성할 경우 증상을 과대 또는 과소 평가 해서는 안됩니다.',
        '증상조사 결과는 근골격계질환의 이환을 부정 또는 입증하는 근거나 반증자료로 활용할 수 없습니다.',
      ]"
    />

    <!-- 파일첨부 -->
    <file-upload-module id="fileList" class="w-full" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import SymptomInvestigationTable from "@/views/boards/single-page/678/SymptomInvestigationTable";
import WarningView from "@/components/WarningView";
import EmployeeSelector from "@/components/selector/EmployeeSelector.vue";
import FieldSelector from "@/components/selector/FieldSelector.vue";
import Multiselect from "vue-multiselect";
export default {
  components: {
    FieldSelector,
    EmployeeSelector,
    WarningView,
    SymptomInvestigationTable,
    FieldSelectModule,
    FileUploadModule,
    Multiselect
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = this.board.writer.department;
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},
        targetInfo: {},
        symptomTable: {},
        fileList: [],

        inputA_0: "",
        inputA_1: "",

        // 292번 게시판에서 사용하는 데이터
        name: '', //이름
        age: '', //나이
        gender: '남', //성별

        fieldNames: [], //사업장명
        workExperience: '', //현 직장경력 (~년/개월)
        workDepartment: '', //작업부서 (~부/라인)
        workLine: '', // 라인
        workPerform: '', //작업(수행작업)


        marriage: '미혼', //결혼여부
        currentWork: '', //현재하고 있는 작업
        currentPeriod1: '',
        currentPeriod2: '',
        dayWorkTime: '', //1일 작업시간
        dayRestTime1: '',
        dayRestTime2: '',
        prevWork: '', //현작업 이전에 하던 작업
        prevPeriod1: '',
        prevPeriod2: '',

      },
    };
  },
  methods: {
    onSelectEmployee(data) {
      console.log(data);

      this.form.inputA_0 = data.id;

      this.form.name = data.full_name;
      this.form.age = this.calculateAge(data.date_of_birth);

      // this.form.companyId = data.fields.length > 0 ? data.fields[0].id : "";
      // this.form.companyName = data.company.com_name;
      this.form.fieldNames = data.fields.map((field) => field.field_name);
      this.form.workExperience = this.calculateExperience(data.hire_date);
      this.form.workDepartment = data.company.com_name;

    },
    calculateAge(birthDate) {
      if (!birthDate) return '';

      // birthDate를 Date 객체로 변환
      const birth = new Date(birthDate);
      const today = new Date();

      // 오늘 날짜와 생일의 차이를 계산 (단위: 년)
      let age = today.getFullYear() - birth.getFullYear();

      // 생일이 아직 오지 않았다면 나이에서 1을 뺌
      const m = today.getMonth() - birth.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < birth.getDate())) {
        age--;
      }

      // 계산된 만나이 반환
      return age;
    },
    calculateExperience(hireDate) {
      if (!hireDate) return '';

      // hireDate를 Date 객체로 변환
      const startDate = new Date(hireDate);
      const currentDate = new Date();

      // 현재 날짜와 시작 날짜의 차이를 계산 (단위: 월)
      let months = (currentDate.getFullYear() - startDate.getFullYear()) * 12;
      months -= startDate.getMonth();
      months += currentDate.getMonth();

      // 연도와 월로 변환
      const years = parseInt(months / 12);
      months %= 12;

      // 'yy년 mm개월' 형식의 문자열로 결과 반환
      return `${years}년/${months}개월`;
    },
  },
  computed: {
    projectId() {
      return parseInt(this.$route.params.proj_id);
    },
    postId() {
      return parseInt(this.$route.params.postId);
    },
    fieldList() {
      if (this.$store.state.project.fieldListInfo.data) {
        return this.$store.state.project.fieldListInfo.data;
      }
      return [];
    },
    fieldNameList() {
      if (this.$store.state.project.fieldListInfo.data) {
        const list = [];
        for (const field of this.$store.state.project.fieldListInfo.data) {
          list.push(field.field_name);
        }

        return list;
      }

      return [];
    },
  },
};
</script>

<style scoped lang="scss"></style>
